/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Review_Con3Inputs */

const en_fc_home_review_con3 = /** @type {(inputs: Fc_Home_Review_Con3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No support for third-party plugins.`)
};

/**
* | output |
* | --- |
* | "No support for third-party plugins." |
*
* @param {Fc_Home_Review_Con3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_review_con3 = /** @type {((inputs?: Fc_Home_Review_Con3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Review_Con3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_review_con3(inputs)
});
export { fc_home_review_con3 as "fc.home.review.con3" }